import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-48 (BU-10) 10a — upload a client-portal logo. The file rides via Relay
 * uploadables (NOT a declared `file` variable value); graphql/ reads it off the
 * request and forwards the bytes to the portal storage. No forecast_db write.
 */
const mutation = graphql`
	mutation uploadClientPortalLogoMutation($input: UploadClientPortalLogoInput!) {
		uploadClientPortalLogo(input: $input) {
			clientPortalConfig {
				portalLogoUrl
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError, uploadables) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, uploadables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
